import React from 'react';
import { Field, reduxForm } from 'redux-form';

import { SSOLoginButton } from './SSOLoginButton';

import TextFieldCSS from '$Fields/TextField/TextField-css';
import FormButton from '$Molecules/Buttons/FormButton';

export class UniversalLoginForm extends React.Component {
    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <form
                onSubmit={handleSubmit}
                data-complete={!invalid && !submitting}
            >
                <Field
                    name="username"
                    component={TextFieldCSS}
                    data={{ label: 'email or username' }}
                />
                <Field
                    name="password"
                    component={TextFieldCSS}
                    data={{ label: 'password', obscured: true }}
                />
                <FormButton
                    pristineText="Sign in"
                    invalidText="Sign in"
                    completeText="Sign in"
                    center={true}
                    {...this.props}
                />
                <SSOLoginButton />
            </form>
        );
    }
}

export default reduxForm({
    form: 'UniversalLoginForm',
    validate: values => {
        const errors = {};
        if (!values.username) {
            errors.username = 'Required';
        }
        if (!values.password) {
            errors.password = 'Required';
        }
        return errors;
    }
})(UniversalLoginForm);
